<template>
  <div class="pad-app-layout">
    <div class="pad-app-header fx-pad-header" v-if="!$route.meta.hideHead">
      <padHeader :IsHome="ishome" :Title="title" /> 
    </div>
    <div class="pad-app-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <div class="fx__line_divide"></div>
    <div class="fx__bgcolor">
      <ul class="pad-app-footer">
        <li v-for="(home, index) in homes" :key="index" class="pad-app-footer-item" :class="{active: activeName==home.name}" @click="go(home)">
          <div class="item">
            <span v-if="home.svg"  style="height:16px;width:16px"> <svg-icon :iconClass="home.svg" class="item_svg"></svg-icon></span>
            <span v-else> <i :class="[home.icon || 'fa fa-navicon', 'fa-lg']"></i></span>
            <span>{{home.text}}</span>
          </div>
        </li>

        <!-- <li v-for="(home, index) in homes" :key="index" class="pad-app-footer-item" :class="{active:activeName==home.name}" @click="go(home)">
          <div class="item" >
            <span><i :class="[home.icon || 'fa fa-navicon', 'fa-lg']"></i></span>
            <span>{{home.text}}</span>
          </div>
        </li>
        <li v-for="(item, idx) in homeNav" :key="`${idx}s`" :class="['pad-app-footer-item',activeName == `core-phoneModulesNav${idx}` ? 'active': '']" @click="goNav(idx)">
          <div class="item">
            <span><i :class="[item.icon || 'fa fa-navicon', 'fa-lg']"></i></span>
            <span>{{item.text}}</span>
          </div>
        </li> -->
      </ul>
    </div>
  </div>

</template>
<script>
import padHeader from "./header";

export default {
  components: { padHeader },
  props: {
    title: String
  },
  data() {
    return {
      homes: [], //菜单
      ishome: true,
      activeName: this.$route.name
    };
  },
  methods: {
    go({ name, children }) {
      this.activeName = name;
      if (children == undefined) {
        this.$app.routeMenuTo(name);
      } else {
        this.$router.push({ path: "/" + name });
      }
    }
    // goNav(para) {
    //   let activePathName = `core-phoneModulesNav${para}`;
    //   this.activeName = activePathName;
    //   this.$router.push({ path: "/" + activePathName });
    // }
  },
  watch: {
    $route: {
      handler: function(to,old) {
        // console.log('------',to.path.replace("/",""))
        // this.activeName = to.path.replace("/","")
        if (this.$route.name === "core-phoneModulesNav") {
          this.activeName = `core-phoneModulesNav${this.$route.params.index}`;
        } else {
          this.activeName = this.$route.name;
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.homes = this.$app.menus.filter(item => {
    //   if (item.children === undefined) return true; // 没有children的菜单
    //   if (item.children.length < 1) return false;
    //   this.homeNav.push(item); // 有children的菜单
    // });
    let _index = 0;
    
    this.homes = this.$app.menus.map(element => {
      if (element.children === undefined) return element;

      let obj = Object.assign({}, element);
      obj.name = `core-phoneModulesNav${_index++}`;
      return obj;
    });
    if (this.$route.name === "core-phoneModulesNav") {
      this.activeName = `core-phoneModulesNav${this.$route.params.index}`;
    } else {
      this.activeName = this.$route.name;
    }
  }
};
</script>

<style lang="scss" >
@import "./pad.scss";
</style>

<style lang="scss" scoped>
.item_svg{
  width: 100%;
  height: 100%;
}
// home页面样式
.pad-app-layout {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  // height: 100vh;
  .pad-app-header {
    height: 50px;
    flex-shrink: 0;
    // background: #2d8cf0;
    color: #fff;
    // padding: 0 10px;
  }
  .pad-app-content {
    overflow: auto;
    flex-grow: 1;
    height: 100%;
  }
  .pad-app-footer {
    z-index: 10;
    height: 50px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-around;
    // border-top: 1px solid #515c69;
    .pad-app-footer-item {
      flex-grow: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all 0.5s;
      position: relative;
      // &.active {
      //   color: #2d8cf0;
      //   a {
      //     color: #2d8cf0;
      //   }
      // }
      // &.active,
      // &.active i {
      //   color: #2d8cf0;
      // }
      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
<style scoped>
.pad-app-footer ::v-deep .ivu-dropdown-rel {
  height: 45px;
  line-height: 45px;
}
</style>